module.exports = __webpack_public_path__ + "img/chrome.719b81d1.svg";